<template>
  <!-- eslint-disable -->
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <div>
        <h2>Manual Call Broadcast</h2>
        <h4>Tracking Number Input</h4>
        <textarea class="tracking-number-input" rows="5" style="border: 1px solid black; width: 100%; padding: 5px;" v-model="trackingNumberString"></textarea>
        <v-select class="call-type-select" content-class="call-type-list" :items="callTypes" v-model="selectedCallType" prepend-icon="call" item-text="label" label="Select Call Type" single-line ></v-select>
        <v-btn dark small color="grey" class="submit-btn" @click="submit()" :disabled="broadcasting || fetchingIds">
          <span v-if="fetchingIds">Submiting...</span>
          <span v-else>Submit</span>
        </v-btn>
        <div class="confirmation-box" style="border: 2px solid #33cc33; margin-top: 20px; padding: 20px;" v-if="errors.length === 0 && showConfirmation">
          <h4>Please confirm that you want to broadcast {{getLabel(selectedCallType)}} type calls to these {{trackingNumbers.length}} package(s).</h4>
          <v-layout row wrap style="margin: 20px 0px 0 0px;">
            <v-flex class="text-xs-left" xs6 >
              <v-btn dark small class="confirm-confirmation-btn" color="#33cc33" @click="confirmBroadcast()">confirm</v-btn>
            </v-flex>
            <v-flex xs6 >
              <v-btn dark small class="cancel-confirmation-btn" color="#e60000" style="float: right; color: white;" @click="showConfirmation = false">cancel</v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="errors.length === 0 && isBroadcasting" class="broadcasting-message" style="margin-top: 20px">
          <h4>Broadcasting calls for {{trackingNumbers.length}} package(s) of type {{getLabel(selectedCallType)}}.</h4>
        </div>
        <div v-if="errors.length === 0 && isBroadcasting && broadcastMessages" style="margin-top: 20px">
          <h4 class="success-message" v-if="broadcastMessages.successfulMessage">{{broadcastMessages.successfulMessage}}.</h4>
          <h4 class="failed-message" v-if="broadcastMessages.failedMessage" style="color: #800000;">{{broadcastMessages.failedMessage}}.</h4>
        </div>
        <div style="border: 2px solid #e60000; margin-top: 20px; padding: 20px;" v-if="errors.length > 0" class="error-box">
          <h3>ERROR</h3>
          <v-layout row wrap v-for="(error, index) in errors" class="error-item" :key="index + 'error'">
            <v-flex class="text-xs-left" xs12 >
              <div style="padding-left: 15px;">{{error}}</div>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>
<script>
import callsModule, { CALLS_NAMESPACE } from "./store/callsStore";
import { mapGetters } from "vuex";
export default {
  name: "ManualCallBroadcast",
  data() {
    return {
      trackingNumberString: "",
      trackingNumbers: [],
      callTypes: [
        { label: "Delayed Delivery", value: "DELAYED_DELIVERY" },
        { label: "Calamity", value: "CALAMITY" }
      ],
      errors: [],
      selectedCallType: "DELAYED_DELIVERY",
      showConfirmation: false,
      isBroadcasting: false,
      fetchingIds: false
    };
  },
  computed: {
    ...mapGetters(CALLS_NAMESPACE, [
      "packageIds",
      "broadcasting",
      "broadcastMessages"
    ])
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(CALLS_NAMESPACE, callsModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.BETA_FEATURE]).then(
      res => {
        if (!res) this.$goHome();
      }
    );
  },
  methods: {
    submit() {
      this.errors = [];
      this.trackingNumbers = [];
      this.showConfirmation = false;
      this.isBroadcasting = false;
      this.convertStringToTrackingNumbers();
      if (this.errors.length === 0) {
        this.fetchingIds = true;
        return this.$store
          .dispatch(
            `${CALLS_NAMESPACE}/submitTrackingNumbers`,
            this.trackingNumbers
          )
          .then(res => {
            this.checkPackagesForUniqueId();
            this.fetchingIds = false;
            if (this.errors.length === 0) {
              this.showConfirmation = true;
            }
          })
          .catch(x => {
            this.fetchingIds = false;
          });
      }
    },
    convertStringToTrackingNumbers() {
      var tempTrackString = this.trackingNumberString.trim();
      if (tempTrackString[tempTrackString.length - 1] === ",") {
        tempTrackString = tempTrackString.substring(
          0,
          tempTrackString.length - 1
        );
      }
      var tempTracking = tempTrackString.split(",");
      for (let i = 0; i < tempTracking.length; i++) {
        tempTracking[i] = tempTracking[i].trim();
        if (!tempTracking[i].match(/^[0-9a-zA-Z]+$/)) {
          this.errors.push(
            "Invalid Tracking Number Format: " + tempTracking[i]
          );
        }
      }
      if (tempTracking.length > 20) {
        this.errors.push(
          "You have exceeded the amount of 20 tracking numbers."
        );
      } else {
        var duplicates = [];
        tempTracking.forEach(number => {
          if (!duplicates.includes(number)) {
            var total = tempTracking.filter(x => {
              return x === number;
            });
            if (total.length > 1) {
              this.errors.push(
                "Tracking Number " +
                  number +
                  " is repeated " +
                  total.length +
                  " times."
              );
              duplicates.push(number);
            }
          }
        });
      }
      if (this.errors.length === 0) {
        tempTracking.forEach(number => {
          this.trackingNumbers.push(number.trim());
        });
      }
    },
    checkPackagesForUniqueId() {
      var packagesPerId = null;
      this.trackingNumbers.forEach(number => {
        packagesPerId = this.packageIds.filter(x => {
          return x.TrackingNumber === number;
        });
        if (packagesPerId.length !== 1) {
          this.errors.push(
            "Tracking Number " +
              number +
              " returned " +
              packagesPerId.length +
              " packages."
          );
        }
      });
    },
    confirmBroadcast() {
      this.isBroadcasting = true;
      this.showConfirmation = false;
      var broadcastData = { Packages: [] };
      this.packageIds.forEach(p => {
        var broadcastJson =
          '{"PackageId":' +
          p.PackageId +
          ', "Type":"' +
          this.selectedCallType +
          '"}';
        broadcastData.Packages.push(broadcastJson);
      });
      this.$store.dispatch(
        `${CALLS_NAMESPACE}/sendCallBroadcastData`,
        broadcastData
      );
    },
    getLabel(value) {
      var type = this.callTypes.find(x => x.value === value);
      if (type) return type.label;
    }
  }
};
</script>
